import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {questionBaseValidator} from './questionBase';

export const questionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.QUESTION),
});
